
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","width":"28","height":"28"}, attrs),
              ...rest,
            },
            children.concat([_c('image',{attrs:{"width":"28","height":"28","xlink:href":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAMAAABF0y+mAAAAIGNIUk0AAHomAACAhAAA+gAAAIDo AAB1MAAA6mAAADqYAAAXcJy6UTwAAACEUExURQAAADh7/zl5/zh6/zl6/zh6/zh3/0Bw/zl6/zd5 /zl5/zh3/zl7/zd5/zl7/0B//zh5/zl5/zh6/0WC/4+0/4Or/1GK/4Os/8DV/3aj/+bv/////+bu /3ej/83e//L3/2mb/16T/83d/6fF/5y9/9rm/7TN/5u8/1GL/8DW/4+1/wAAAAGZj8QAAAASdFJO UwBAj9/PnyAQkI/PQM/PjxDfP5LbpTEAAAABYktHRACIBR1IAAAACXBIWXMAAAsTAAALEwEAmpwY AAAAB3RJTUUH5wwEAzkjI6K5XQAAALRJREFUKM+dktkSgjAMRWOhLKKiUVEIiiug//+BFrAVteGB 85TmTDLTyQVQTISDX7jSgw4/QAuh3zoXrUwbGyBDCOAhSwSSlwJmvdd6s016Twd0tdunmBHleDim umdkQafzRZGkVPxJomtX3Igsko4Nd7JLg02WlaJkZPuNeuTaByvV2icrB9eOlNnH5UbqaNWVQZ9t Dgv+2BIiXqp4sqNCpS8eiibE1lnhvzPvyZ/ppVg1/RdpdTpGsMF7OwAAACV0RVh0ZGF0ZTpjcmVh dGUAMjAyMy0xMi0wNFQwMjozMjoxMiswMDowMFZ4qEIAAAAldEVYdGRhdGU6bW9kaWZ5ADIwMjMt MTItMDRUMDI6MzI6MTMrMDA6MDCBUhtKAAAAKHRFWHRkYXRlOnRpbWVzdGFtcAAyMDIzLTEyLTA0 VDAzOjU3OjM1KzAwOjAwJLjQUAAAAABJRU5ErkJggg=="}})])
          )
        }
      }
    